export default "__VITE_ASSET__BLPI4Cou__"